"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const form_ejs_1 = require("./form.ejs");
const align_ejs_1 = require("./align.ejs");
exports.default = { form: form_ejs_1.default, align: align_ejs_1.default };
